import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Spin } from '@jjj/components';
import { t } from '../../../../../../../../i18n';
import { SpinWrapper, SelectSubsection, MissingActionsContainer } from './selectionTooltip.style';
import { LockedIcon } from '../../../../../../../../components/tables/cells.style';

const BulkActionsList = ({ loading, actions, onActionClick }) => (
  <SelectSubsection>
    <span className="actions-header">{t('dash.jobs.bookings.pools_actions_label')}</span>
    {loading && (
      <SpinWrapper>
        <Spin />
      </SpinWrapper>
    )}
    {!loading && !!actions.length && (
      <ul className="list-no-style">
        {actions.map(action => (
          <li key={action.key}>
            <Button
              type="link"
              disabled={action.options.locked}
              key={action.key}
              onClick={event => onActionClick(event, action)}
              data-cy="job-booking-pool-bulk-action-list-action-button"
            >
              {action.options.locked && (
                <LockedIcon>
                  <FontAwesomeIcon icon="lock" />
                </LockedIcon>
              )}
              {t(`dash.jobs.bookings.poolList.actions.${action.key}`)}
            </Button>
          </li>
        ))}
      </ul>
    )}

    {!loading && !actions.length && (
      <MissingActionsContainer>
        <span>{t('dash.jobs.bookings.poolList.bulk_actions_missing')}</span>
      </MissingActionsContainer>
    )}
  </SelectSubsection>
);

export default BulkActionsList;
